// extracted by mini-css-extract-plugin
export default {"table":"table_table__zIOkj","disabled":"table_disabled__LF4Gw"};